module.exports = __webpack_public_path__ + "img/logo.d19e1cf0.svg";